<div class="rectangle-count" fxLayout="column" fxLayoutAlign="space-between">
  <p class="count">{{ amount && amount !== 'null' ? amount : '-'}}</p>
  <p class="details" *ngIf="label">{{ label }}</p>
  <i *ngIf="tooltip" class="{{ icon || 'far fa-info-circle' }}" [ngxTippy]="tooltip" [tippyProps]="tippyProps"
    tippyClassName="meeting-info-tooltip"></i>
</div>
